export enum ServiceWorkerAction {
  ExportPptAction = 'EXPORT_MULTI_QUESTION_PPT',
  ExportExcelAction = 'EXPORT_EXCEL',
  AbortExportAction = 'ABORT_EXPORT',
}
